import {Component, OnInit, ViewChild} from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';

import {User} from 'classes/user';
import {UserRole} from 'shared/classes/user-role';
import { TargetGroupsHelper } from 'shared/helper/targetGroupsHelper';
import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import { TargetGroup } from 'shared/models/target-groups/target-group';
import {UserListService} from './services/user-list.service';

@Component({
  selector: 'user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css'],
})

export class UserListComponent implements OnInit {

  private allUsers: Array<User>;
  public filteredUsers: Array<User>;
  public fieldsToSearch: Array<Array<string>> = [];
  public activeStatus: 'all' | 'active' | 'inactive' = 'all';
  public currentPage: Event;

  public sortType = null;
  public sortReverse = false;

  private targetGroupsHelper: TargetGroupsHelper;

  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private userListService: UserListService, private router: Router) {
    this.allUsers = [];
  }

  public ngOnInit(): void {
    this.userListService.getUsers()
      .subscribe((allUsers: Array<User>) => {
        this.allUsers = allUsers;
        this.filteredUsers = allUsers;
        this.prepareFieldsToSearch();
      });
    this.userListService.getAllTargetGroups()
      .subscribe((targetGroups: Array<TargetGroup>) => {
        this.targetGroupsHelper = new TargetGroupsHelper(targetGroups);
      });
  }

  public createUser(): void { // tslint:disable-line
    this.router.navigate(['user', 'details']);
  }

  private editUser(id: number): void { // tslint:disable-line
    this.router.navigate(['user', 'details', {userId: id}]);
  }

  public importUser(): void {
    this.router.navigate(['user', 'import']);
  }

  public deleteUser(id: number): void { // tslint:disable-line
    this.userListService.deleteUser(id)
      .subscribe((deleteResponse: Response) => {
        const index: number = this.allUsers.findIndex((user: User) => {
          return user._id === id;
        });

        if (index > -1) {
          this.allUsers.splice(index, 1);
        }
      });
  }

  public get filteredUsersByActiveStatus(): Array<User> {
    return this.allUsers.filter((user) => {
      return this.filterByActiveStatus(user);
    });
  }

  public showDeleteModal(userId: number): void { // tslint:disable-line
    const user: User = this.getUserById(userId);
    const content: string = `Sind Sie sicher, dass Sie den Benutzer
      "${user.firstname} ${user.lastname}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(userId)
      .show();
  }

  public getActiveIcon(user: User): string { // tslint:disable-line
    return user.active ? 'glyphicon-ok' : 'glyphicon-remove';
  }

  public getActiveClass(user: User): string { // tslint:disable-line
    return user.active ? 'no-button-success' : 'no-button-danger';
  }

  public filterUsers(eventUsers: Array<User>): void {
    this.filteredUsers = this.sortBy(eventUsers, this.sortType, this.sortReverse);
  }

  private sortBy(users: Array<User>, prop: string, reverse: boolean): Array<User> {
    if (prop == null) {
      return users;
    }
    const dir = reverse ? -1 : 1;
    return users.sort((a, b) => a[prop] > b[prop] ? dir : a[prop] === b[prop] ? 0 : -dir);
  }

  public prepareFieldsToSearch(): void {
    this.fieldsToSearch = [];
    this.filteredUsersByActiveStatus.forEach((user) => {
      let companyName = this.getUserCompanyText(user);
      if (companyName === undefined) {
        companyName = '';
      };
      user['company.name'] = companyName; // help field for sorting
      this.fieldsToSearch.push([
        user._id.toString().toLowerCase(),
        user.email.toLowerCase(),
        user.firstname ? user.firstname.toLowerCase() : '',
        user.lastname ? user.lastname.toLowerCase() : '',
        companyName.toLowerCase()
      ]);
    });
  }

  private getUserById(id: number): User {
    return this.allUsers.find((user) => {
      return user._id === id;
    });
  }

  private filterByActiveStatus(user: User): boolean {
    if (this.activeStatus === 'all') {
      return true;
    }

    const active: boolean = this.activeStatus === 'active';
    return user.active === active;
  }

  public getUserRolesText(user: User): string {
    return user.roles.map((role: UserRole) => {
      let roleText = role.name;
      if (roleText.startsWith('APP_')) {
        roleText = roleText.substr('APP_'.length);
      }

      return roleText;
    }).join(', ');
  }

  public getUserCompanyText(user: User): string {
    const userHasNoCompany: boolean = user.company === undefined || user.company === null;
    if (userHasNoCompany) {
      return '';
    }

    return user.company.name;
  }

  public getUserTargetGroups(user: User): string {
    if ( this.targetGroupsHelper == null ) {
      return "";
    }
    return this.targetGroupsHelper.getTargetGroups(user)
      .map(targetGroup => targetGroup.title)
      .join(", ")
  }

  public setSort(type) {
    if (this.sortType == type) {
      this.sortReverse = !this.sortReverse
    } else {
      this.sortType = type;
      this.sortReverse = false;
    }
    this.filteredUsers = this.sortBy(this.filteredUsers, this.sortType, this.sortReverse);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/user/user-list/user-list.component.ts